import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Url } from '@nio-pow/mfe-vue3'
import { LayoutEventHub } from './LayoutUtils'
import { isPurePagePath } from '@/utils/constants'

export default function useLayout() {
  const route = useRoute()

  // 左侧菜单是否折叠
  const isAsideCollapsed = ref(false)

  // 是否全屏
  const isFullscreen = ref(false)

  // -------------- methods
  const handleCollapseStatusChange = (isCollapse: boolean) => {
    isAsideCollapsed.value = isCollapse
    // LayoutEventHub.syncCollapseStatusChange(isCollapse)
  }

  const _initUrlParams = () => {
    const fullscreen = Url.getUrlSearch('fullscreen')
    if (fullscreen === 'true') isFullscreen.value = true
  }

  // 纯页面路由（meta.purePage，由 router/beforeEach 按前缀打标）：
  // 与 fullscreen 参数同效——隐藏 HeaderNav 与菜单、清零安全区；
  // 离开纯页面且 URL 未显式要求 fullscreen 时自动恢复常规布局。
  // 初始化直读 location.pathname：首帧渲染早于路由初始导航确认（此时
  // route.meta 为空），读 meta 会先闪一帧常规布局再被挤掉。
  const _syncPurePage = () => {
    if (route.meta?.purePage) {
      isFullscreen.value = true
    } else if (Url.getUrlSearch('fullscreen') !== 'true') {
      isFullscreen.value = false
    }
  }

  const _isPurePathNow = () => isPurePagePath(window.location.pathname)

  // -------------- init
  _initUrlParams()
  // 首帧前同步置位即可，切勿再调 _syncPurePage()：此时路由 meta 为空，
  // 其 else 分支会把刚置的 true 冲掉，闪帧复现；后续变化交给下方 watch
  if (_isPurePathNow()) isFullscreen.value = true

  watch(() => route.meta?.purePage, _syncPurePage)

  LayoutEventHub.isFullscreen = isFullscreen.value
  LayoutEventHub.onFullscreenChange((fullscreen: boolean) => {
    if (typeof fullscreen === 'boolean') {
      isFullscreen.value = fullscreen
    }
  })

  return {
    isFullscreen,
    isAsideCollapsed,
    handleCollapseStatusChange
  }
}
